module.exports = __webpack_public_path__ + "img/iPhone_01.5041abe1.png";